import { render, staticRenderFns } from "./PreviewForm.vue?vue&type=template&id=5ca3be58&"
import script from "./PreviewForm.vue?vue&type=script&lang=js&"
export * from "./PreviewForm.vue?vue&type=script&lang=js&"
import style0 from "./PreviewForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports